import React from 'react';
import { Box, Tooltip } from '@mui/material';
import { WhatsApp } from '@mui/icons-material';
import { useBusiness } from '../context/BusinessContext';
import { WHATSAPP_BASE_URL } from '../services/api';

const FloatingWhatsApp = () => {
  const { businessInfo } = useBusiness();
  const phone = businessInfo?.whatsapp || businessInfo?.phone || '';
  const digits = phone.replace(/[^0-9]/g, '');
  const message = encodeURIComponent('Hola Descorcha2, quisiera consultar por vinos y bebidas.');

  if (!digits) return null;

  return (
    <Tooltip title="Consultanos por WhatsApp" placement="left">
      <Box
        component="a"
        className="floating-whatsapp"
        href={`${WHATSAPP_BASE_URL}${digits}?text=${message}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Consultar a Descorcha2 por WhatsApp"
      >
        <WhatsApp />
      </Box>
    </Tooltip>
  );
};

export default FloatingWhatsApp;
